import {useSelector, useDispatch} from 'react-redux'
import {useMemo, useRef} from 'react'
import {selectChartMarkers, updateChartMarkerData} from '../slices/chartMarkerSlice'

export const useChartMarker = () => {
  const chartMarkersState = useSelector(selectChartMarkers)
  const dispatch = useDispatch()

  // Use a ref to maintain the same API as the original provider
  // This allows components to mutate the chartMarkers.current directly
  const chartMarkers = useRef(chartMarkersState)

  // Update ref when Redux state changes
  chartMarkers.current = chartMarkersState

  const updateMarker = useMemo(
    () => (chartName, lineLabels) => {
      dispatch(updateChartMarkerData({chartName, lineLabels}))
    },
    [dispatch]
  )

  return useMemo(
    () => ({
      chartMarkers,
      updateMarker
    }),
    [updateMarker]
  )
}
